import { all, takeLatest } from 'lib/redux';
import {
  GET_INIT_PARAMETERS,
  LOAD_USER_PRODUCTS,
  LOAD_PRODUCT_CATALOG, // #genai
  GET_USER_ENTITLED_APPS,
  GET_ENTITLED_THIRDPARTY_APPS, // #genai
  GET_USER_PROFILE,
  LOAD_CONSUMPTION_DATA,
} from 'constants/ActionTypes';
import {
  getInitParametersSaga, getUserEntitledAppsSaga, getEntitledThirdPartyAppsSaga, getUserProductsSaga, getProductCatalogSaga, getUserProfileSaga, // #genai
  loadConsumptionDataSaga,
} from './UserData.saga';
/**
 * Defines the watchers related to Init parameters.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(GET_INIT_PARAMETERS, getInitParametersSaga),
    takeLatest(LOAD_USER_PRODUCTS, getUserProductsSaga),
    takeLatest(LOAD_PRODUCT_CATALOG, getProductCatalogSaga), // #genai
    takeLatest(GET_USER_ENTITLED_APPS, getUserEntitledAppsSaga),
    takeLatest(GET_ENTITLED_THIRDPARTY_APPS, getEntitledThirdPartyAppsSaga), // #genai
    takeLatest(GET_USER_PROFILE, getUserProfileSaga),
    takeLatest(LOAD_CONSUMPTION_DATA, loadConsumptionDataSaga),
  ]);
}
